<template>
    <tr>
        <td class="border-b border-gray py-2 px-2">
            {{ item.product.title }}
            <span v-if="item.product.description"> - {{ item.product.description }}</span>
            <span v-if="item.product.size"> - {{ item.product.size }}</span>
            <div v-if="item.product.special_order" class="leading-tight text-xs italic font-bold text-red">{{ specialOrderLeadLabel }}</div>
            <div><small><a href="#" class="removeFromCart" @click.prevent="removeFromCart()">Remove</a></small></div>
        </td>
        <td class="border-b border-gray py-2 px-2 text-right">{{ toCurrency(Number(item.price)) }}</td>
        <td v-if="!isTaxExemptCustomer" class="border-b border-gray py-2 px-2 text-center">
            <img v-if="item.product.taxable" src="/images/icons/check.svg" width="24" height="24" class="mx-auto"/>
            <img v-else src="/images/icons/x.svg" width="24" height="24" class="mx-auto" />
        </td>
        <td class="border-b border-gray py-2 px-2 text-center">
            <div class="relative">
                <!-- Limited by stock qty message  -->
                <jet-tooltip v-show="showStockWarning">
                    Only {{ item.product.available * 1}} Available
                </jet-tooltip>

                <input-quantity
                    v-model.lazy.number="quantity"
                    class="quantity text-center w-20"
                    :step="item.product.allow_partial_quantity ? 0.5 : 1"
                    :lazy="true"
                    :max="item.product.available"
                    @stockWarning="stockWarning"
                />
            </div>
        </td>
        <td class="border-b border-gray py-2 px-2 text-right">{{ toCurrency(total) }}</td>
    </tr>
</template>

<script>
import UseCart from '@/Composables/UseCart';
import { usePage } from '@inertiajs/inertia-vue3'
import InputQuantity from '@/Jetstream/InputQuantity';
import JetTooltip from '@/Jetstream/Tooltip';
import { specialOrderLeadTimeLabel } from '@/helper';

export default {
    props: ['item', 'isTaxExemptCustomer'],

    setup () {
        const { updateCart } =
            UseCart(
                usePage().props.value.user,
                usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.tax_exempt : 0
            );

        return {
            updateCart,
        }
    },

    components: {
        InputQuantity,
        JetTooltip,
    },

    data() {
        return {
            quantity: this.item.quantity,

            showStockWarning: false,
            stockWarningTimeout: null,
        }
    },

    methods: {
        removeFromCart () {
            this.updateCart(this.item.product, 0, true);
        },

        stockWarning () {
            if (this.stockWarningTimeout) clearTimeout(this.stockWarningTimeout);

            this.showStockWarning = true;

            this.stockWarningTimeout = setTimeout(() => {
                this.showStockWarning = false;
                clearTimeout(this.stockWarningTimeout);
            }, 2 * 1000);
        }
    },

    computed: {
        specialOrderLeadLabel () {
            return specialOrderLeadTimeLabel(this.item.product.special_order_lead_hours);
        },
        total () {
            let total = this.item.quantity * this.item.price;

            return Math.round(total * 100) / 100;
        }
    },

    watch: {
        quantity (newValue) {
            this.updateCart(this.item.product, newValue);
        },

        'item.quantity' (newValue) {
            this.quantity = newValue;
        }
    }
}
</script>

<style>
.removeFromCart, .removeFromCart:hover {
    color: #ff5047;
}
.removeFromCart:hover {
    text-decoration: underline;
}
</style>